var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.037 38.4764C127.526 36.2537 127.784 33.9442 127.784 31.5744C127.784 29.0223 127.485 26.5401 126.92 24.161H55.6958V38.4764H127.037ZM123.435 47.6791H77.1689V61.9945H105.639C113.184 59.5637 119.503 54.4044 123.435 47.6791ZM103.879 0.642853C112.001 2.75051 118.868 7.9726 123.129 14.9582H54.4176L62.0866 0.642853H103.879Z",
    fill: "#1F1D1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5615 45.3809C11.4792 23.6521 27.0728 -2.67795 48.2901 1.15653C37.298 4.22414 20.7621 23.3965 51.8691 50.7491C69.7197 66.4454 85.5655 83.5544 93.1158 91.7066L93.5371 92.1615C116.033 116.447 108.359 148.744 88.6801 152.235H76.6652C97.6272 140.987 94.0484 116.702 81.778 102.898C61.8387 80.4663 40.8174 65.9191 26.5615 45.3809Z",
    fill: "#C1255D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43428 63.5308C-7.95104 46.1455 -0.675897 11.8908 30.8436 1.66786C11.293 13.6802 0.120583 35.3621 28.8622 61.7414C47.5233 78.8687 62.9817 94.2066 75.3873 108.266C94.5596 129.995 77.1767 157.092 52.3805 151.979C72.5753 135.363 74.8415 127.12 50.3354 103.921C31.1629 85.7708 34.2305 88.3271 9.43428 63.5308Z",
    fill: "#1F1D1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5234 34.133C35.479 20.8596 46.5008 -3.18922 67.9103 1.16207C52.3804 9.08112 56.7261 23.6521 66.6958 32.3436C74.8276 39.4329 105.816 70.3957 112.965 78.613C135.205 104.176 134.694 146.1 98.3942 152.241C118.464 139.645 118.333 119.003 108.875 99.5749C93.0259 75.5454 72.5752 61.7413 47.5234 34.133Z",
    fill: "#1F1D1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7193 104.943C11.7271 104.943 4.05813 109.542 1.25399 120.025C-3.8587 101.62 10.1933 90.6277 25.539 90.7373C29.6305 90.7665 32.9524 90.6277 37.5538 90.6277L53.4029 104.943H22.7193Z",
    fill: "#1F1D1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9827 114.657H60.5606H68.4852V128.206H26.8094C9.43422 128.206 8.07083 143.118 9.43422 148.912C-5.39246 136.897 2.77998 114.657 22.9827 114.657Z",
    fill: "#1F1D1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.065 138.175H66.1845L59.5381 152.491H15.825C14.598 143.493 22.7193 138.175 27.065 138.175Z",
    fill: "#1F1D1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aa2e9c10.svg";
export { ForwardRef as ReactComponent };